import _ from 'lodash'

const snakeCaseKeys = (node) => {
  if (_.isArray(node)) {
    return _.map(node, snakeCaseKeys)
  }
  if (_.isPlainObject(node)) {
    return _.transform(node, (result, value, key) =>
      _.set(result, _.snakeCase(key), _.isObjectLike(value) ? snakeCaseKeys(value) : value),
    )
  }

  return node
}

export default snakeCaseKeys
